import http from "./http_common";

class PaymentService {
  queryString(payload) {
    return Object.keys(payload)
      .map((key) => key + "=" + payload[key])
      .join("&");
  }
  PhonepeTransaction(data) {
    return http.post(`/phonepeTransaction/consultation/save`, data);
  }
  PhonepeCartTransaction(data) {
    return http.post(`/phonepeTransaction/`, data);
  }
  BillingCartTransaction(data) {
    return http.post(`/billingTransaction/`, data);
  }
  BillingTransaction(data) {
    return http.post(`/billingTransaction/consultation/save`, data);
  }
  getTransactionStatus(payload) {
    var queryString = this.queryString(payload);
    return http.get(`phonePeResponse1/paymentRedirectDetails?${queryString}`);
  }
  getBillingTransaction(payload) {
    var queryString = this.queryString(payload);
    return http.get(`billingTransaction/list/filter?${queryString}`);
  }
  AppointmentUpdate(data) {
    return http.put(`/invitationDetails/update-status/${data?.id}`, data);
  }
  CartUpdate(id, data) {
    return http.put(`/CartDetails/update-status/${id}`, data);
  }
  getBillingCount(payload) {
    var queryString = this.queryString(payload);
    return http.get(
      `/billingTransaction/getBillingTransactionCountStatus?${queryString}`,
    );
  }
  GetAppointmentId(payload) {
    var queryString = this.queryString(payload);
    return http.get(`invitationDetails/list/filter?${queryString}`);
  }

  initiatePayment(payload) {
    return http.post("/phonePeResponse1/phonepe/payment-initiate", payload);
  }

  V2initiatePayment(payload) {
    return http.post("/phonePeResponse1/createPayment", payload);
  }
}
export default new PaymentService();
